import "./style.css";
import MobilePw from "./MobilePowerlifting";

function Powerlifting(props: any) {
  const {
    isDesktop,
    powerliftingDescription1,
    powerliftingDescription2,
    squatDescription1,
    squatDescription2,
    squatImage,
    benchDescription1,
    benchDescription2,
    benchImage,
    deadliftDescription1,
    deadliftDescription2,
    deadliftImage,
  } = props;

  return (
    <div className="Pw">
      {isDesktop ? (
        <>
          <div id="pw" className="pw-area">
            <div className="pw-content">
              <h2 className="pw-title">ERŐEMELÉS</h2>
              <h1 className="pw-title2">A SZAKTERÜLETÜNK</h1>
              <div className="pw-text-columns">
                <div className="pw-column">
                  <p>{powerliftingDescription1}</p>
                </div>
                <div className="pw-column">
                  <p>{powerliftingDescription2}</p>
                </div>
              </div>
              <div className="pw-boxes">
                <div className="pw-box">
                  <div className="pw-image">
                    <img src={squatImage} alt="Squat"></img>
                  </div>
                  <div className="pw-description">
                    <h3 className="pw-box-title">
                      Miért ajánljuk az erőemelést mint versenysportot?
                    </h3>
                    <p>{squatDescription1}</p>
                    <br />
                    <p>{squatDescription2}</p>
                  </div>
                </div>
                <div className="pw-box">
                  <div className="pw-description">
                    <h3 className="pw-box-title">
                      Miért ajánljuk hobbi sportnak?
                    </h3>
                    <p>{benchDescription1}</p>
                    <br />
                    <p>{benchDescription2}</p>
                  </div>
                  <div className="pw-image">
                    <img src={benchImage} alt="Bench Press"></img>
                  </div>
                </div>
                <div className="pw-box">
                  <div className="pw-image">
                    <img src={deadliftImage} alt="Deadlift"></img>
                  </div>
                  <div className="pw-description">
                    <h3 className="pw-box-title">
                      Miért jó kiegészítőnek más sportokhoz?
                    </h3>
                    <p>{deadliftDescription1}</p>
                    <br />
                    <p>{deadliftDescription2}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <MobilePw
          powerliftingDescription1={powerliftingDescription1}
          powerliftingDescription2={powerliftingDescription2}
          squatDescription1={squatDescription1}
          squatDescription2={squatDescription2}
          squatImage={squatImage}
          benchDescription1={benchDescription1}
          benchDescription2={benchDescription2}
          benchImage={benchImage}
          deadliftDescription1={deadliftDescription1}
          deadliftDescription2={deadliftDescription2}
          deadliftImage={deadliftImage}
        ></MobilePw>
      )}
    </div>
  );
}
export default Powerlifting;
